import React from 'react';
import Header from './components/header/Header';
import Home from './components/home/Home';
import Office from './components/localisation/Office';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import InfoBanner from './components/info/InfoBanner';

const App: React.FC = () => {
    return (
    <div style={{ backgroundColor: "var(--luxe-sand)" }}>
      <Header />
      <InfoBanner />
      <Home />
      <Office/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
